import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { DowngradeModalService } from './downgrade-modal.service';

export const ngxDowngradeModalServiceModule = angular.module('ngxDowngradeModalServiceModule', [])
	.factory('ngxDowngradeModalService', downgradeInjectable(DowngradeModalService) as any)
	.name;
